import Modal from '@/components/modal/modal.component'
import ContactUsForm from '@/components/SHARED/contact-us/contact-us-form.component'
import React from 'react'

const FeedbackModal = ({
    show,
    cancel
}) => {
  return (
    <div className='feedback-modal'>
        <Modal 
            show={show} 
            cancel={cancel}
            closeButton={true}
            text="Send Us Feedback"
            cls="narrow"
            >
            <ContactUsForm 
                tall={true}
                cancel={cancel} />
        </Modal>
    </div>
  )
}

export default FeedbackModal